module.exports = __webpack_public_path__ + "img/barraFondo2.d517e8e2.svg";